import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { PromotorCategoryAssignmentModel } from 'src/app/model/promotor-category-assignment.model';
import { PromotorCategoryAssignmentService } from 'src/app/services/promotor-category-assignment.service';
import { EmployeesService } from 'src/app/services/employees.service';
import { CatCategoryPromoterService } from 'src/app/services/cat-category-promoter.service';
import { CreatorService } from 'src/app/services/creator.service';
import { ModalPromotorCategoryAssignmentComponent } from 'src/app/shared/modal-promotor-category-assignment/modal-promotor-category-assignment.component';

@Component({
  selector: 'app-promotor-category-assignment',
  templateUrl: './promotor-category-assignment.component.html',
  styleUrls: ['./promotor-category-assignment.component.css']
})
export class PromotorCategoryAssignmentComponent implements OnInit {
  public viewStatus = 0;  // -1:error, 0:spinner, 1:tabla
  public assignments: PromotorCategoryAssignmentModel[] = [];
  public employeesList: any[] = [];
  public categoriesList: any[] = [];

  dtOptions = {
    order: [],
    responsive: true,
    columnDefs: [
      { responsivePriority: 1, width: 100, targets: -1 }
    ],
    bLengthChange: true,
    searching: true,
    dom: '<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
    buttons: ['csv', 'excel'],
    autoWidth: false,
    paging: true,
    pageLength: 100,
    language: {
      processing: 'Procesando...',
      search: 'Buscar:',
      lengthMenu: 'Mostrar _MENU_ elementos',
      info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
      infoEmpty: 'Mostrando ningún elemento.',
      infoFiltered: '(filtrado _MAX_ elementos total)',
      infoPostFix: '',
      loadingRecords: 'Cargando registros...',
      zeroRecords: 'No se encontraron registros',
      emptyTable: 'No hay datos disponibles en la tabla',
      paginate: {
        first: 'Primero',
        previous: 'Anterior',
        next: 'Siguiente',
        last: 'Último'
      },
      aria: {
        sortAscending: ': Activar para ordenar la tabla en orden ascendente',
        sortDescending: ': Activar para ordenar la tabla en orden descendente'
      },
      buttons: ['excel']
    }
  };

  constructor(
    private creator: CreatorService,
    private modalService: NgbModal,
    private assignmentService: PromotorCategoryAssignmentService,
    private employeesService: EmployeesService,
    private categoriesService: CatCategoryPromoterService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.getCatalogs();
  }

  add = () => {
    let entity = this.creator.newPromotorCategoryAssignment();
    let modalRef = this.modalService.open(ModalPromotorCategoryAssignmentComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
      windowClass: 'dark-modal'
    });
    modalRef.componentInstance.entity = { ...entity };
    modalRef.componentInstance.employees = this.employeesList;
    modalRef.componentInstance.categories = this.categoriesList;
    modalRef.componentInstance.mode = 'create';
    modalRef.result.then(
      data => console.log(data),
      reason => {
        console.log(reason);
        this.viewStatus = 0;
        this.getCatalogs();
      }
    );
  }

  edit = (entity: PromotorCategoryAssignmentModel) => {
    let modalRef = this.modalService.open(ModalPromotorCategoryAssignmentComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
      windowClass: 'dark-modal'
    });
    modalRef.componentInstance.entity = { ...entity };
    modalRef.componentInstance.employees = this.employeesList;
    modalRef.componentInstance.categories = this.categoriesList;
    modalRef.componentInstance.mode = 'edit';
    modalRef.result.then(
      data => console.log(data),
      reason => {
        console.log(reason);
        this.viewStatus = 0;
        this.getCatalogs();
      }
    );
  }

  getCatalogs = () => {
    this.viewStatus = 0;
    forkJoin([
      this.assignmentService.getAll().pipe(catchError(e => of({ data: [] }))),
      this.employeesService.getAll().pipe(catchError(e => of({ data: [] }))),
      this.categoriesService.getAll().pipe(catchError(e => of({ data: [] })))
    ]).pipe(
      tap(([assignments, employees, categories]) => {
        this.assignments = assignments.data || [];
        this.employeesList = employees.data || [];
        this.categoriesList = categories.data || [];
        this.viewStatus = 1;
      }),
      catchError(error => {
        this.toastr.error('Error al cargar catálogos');
        this.viewStatus = -1;
        return of(null);
      })
    ).subscribe();
  }

  getEmployeeName(employeeId: string): string {
    const employee = this.employeesList.find(e => e.vIdempleado === employeeId);
    return employee ? employee.vNombreEmpleado : employeeId;
  }

  getCategoryName(categoryId: number): string {
    const category = this.categoriesList.find(c => c.promoterCategoryId === categoryId);
    return category ? category.description : 'N/A';
  }
}
